import { type FC, memo } from 'react';
import { TOURNAMENTS_CAMPAIGN_TYPE, REBATE_CAMPAIGN_TYPE } from '../../../types/campaign.types';
import type { CountdownDirection } from './countdownHelpers';
import SimpleCountdownTimer from './variants/simpleTimer/SimpleCountdownTimer';
import IntervalCountdownTimer from './variants/intervalTimer/IntervalCountdownTimer';
import { useCampaignTypeContext } from '../../../store/context/CampaignTypeContext';

interface CountdownTimerProps {
  campaignId?: string;
  children: (props: {
    label: string;
    valueRef: React.RefObject<HTMLSpanElement | null>;
    direction: CountdownDirection;
    initialValue: string;
    lessThanHour?: boolean; // used only for Tournaments
  }) => React.ReactNode;
}

/**
 * Campaign-type-aware countdown timer.
 * Resolves the correct timer variant based on the campaign type:
 * - Looks up type by campaignId (works for real campaign IDs)
 * - Falls back to the section context, then the global campaignType from the store
 */
const CountdownTimer: FC<CountdownTimerProps> = ({ campaignId, children }) => {
  const campaignType = useCampaignTypeContext();

  if (campaignType === TOURNAMENTS_CAMPAIGN_TYPE || campaignType === REBATE_CAMPAIGN_TYPE) {
    return (
      <SimpleCountdownTimer campaignId={campaignId}>
        {children}
      </SimpleCountdownTimer>
    );
  }

  // Prize pops
  return (
    <IntervalCountdownTimer campaignId={campaignId}>
      {children}
    </IntervalCountdownTimer>
  );
};

export default memo(CountdownTimer);
